import React from 'react'
import Taxonomy from './Taxonomy/Taxonomy'
import PrimaryCategories from './PrimaryCategories/PrimaryCategories'
import styles from './styles.module.css'
import RawCategory from './RawCategories/RawCategories'

function Categorization ({
  localTaxonomyLevel1,
  setLocalTaxonomyLevel1,
  localTaxonomyLevel2,
  setLocalTaxonomyLevel2,
  localTaxonomyLevel3,
  setLocalTaxonomyLevel3,
  localPrimaryCategories,
  setLocalPrimaryCategories,
  localRawCategory,
  setLocalRawCategory
}) {
  return (
    <div>
      <h1 className={styles.TitleCategorization}>Categorization</h1>
      <Taxonomy
        localTaxonomyLevel1={localTaxonomyLevel1}
        setLocalTaxonomyLevel1={setLocalTaxonomyLevel1}
        localTaxonomyLevel2={localTaxonomyLevel2}
        setLocalTaxonomyLevel2={setLocalTaxonomyLevel2}
        localTaxonomyLevel3={localTaxonomyLevel3}
        setLocalTaxonomyLevel3={setLocalTaxonomyLevel3}
      />
      <PrimaryCategories localPrimaryCategories={localPrimaryCategories} setLocalPrimaryCategories={setLocalPrimaryCategories} />
      <RawCategory localRawCategory={localRawCategory} setLocalRawCategory={setLocalRawCategory}  />
    </div>
  )
}

export default Categorization
